<p-dialog
  p-dialog
  appendTo="body"
  header="{{ 'ReceiptFormHeaderDetails.Button.EditRelatedBillBtn' | translate }}"
  [style]="{width: '60vw'}"
  [(visible)]="isVisible"
  (onHide)="dialogVisibleChange(false)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true">

  <div class="mt-2">
    <Form [formGroup]="formGroup">
      <div class="p-fluid formgrid grid">
        <div class="field grid col-6 align-items-baseline">
          <label class="col-3 column-label">{{ 'ReceiptFormHeaderDetails.ReceiptNum' | translate }}</label>
          <div class="col-8 column-value">
              {{ warehousingHeader?.whNo | replaceNullWith:'-' }}
          </div>
        </div>

        <div class="field grid col-6 align-items-baseline"></div>

        <div class="field grid col-6 align-items-baseline">
          <label class="col-3 column-label">{{ 'ReceiptFormHeaderDetails.DeliveryType' | translate }}</label>
          <div class="col-8 column-value">
            <ng-container [ngSwitch]="warehousingHeader.deliveryType">
              <div *ngSwitchCase="'DECLARATION'">{{ warehousingHeader?.deliveryType | replaceNullWith:'-' }}</div>
              <div *ngSwitchDefault>
                <p-dropdown
                  formControlName="deliveryType"
                  appendTo="body"
                  [options]="deliveryTypeOptions"
                  [(ngModel)]="warehousingHeader.deliveryType"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                </p-dropdown>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="field grid col-6 align-items-baseline">
            <label class="col-3 column-label">{{'ReceiptFormHeaderDetails.TradeTerm' | translate}}</label>
            <div class="col-8 column-value">
              <p-dropdown
                  formControlName="shipTerm"
                  appendTo="body"
                  [(ngModel)]="warehousingHeader.shipTerm"
                  [options]="shipTermOptions"
                  [showClear]="true"
                  (onChange)="changeShipTerm($event)"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [disabled]="warehousingHeader.deliveryType === 'LOCAL'"
                  styleClass="p-text-left">
              </p-dropdown>
            </div>
        </div>

        <div class="field grid col-6 align-items-baseline">
          <label class="col-3 column-label"><span class="requiredStart">*</span>{{'ReceiptFormHeaderDetails.OrgId' | translate}}</label>
          <div class="col-8 column-value">
            <p-dropdown
              formControlName="orgId"
              [filter]="true"
              appendTo="body"
              [(ngModel)]="warehousingHeader.orgId"
              [options]="orgIdOptions"
              (onChange)="changeBillCorpOptions()"
              [showClear]="true"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              styleClass="p-text-left">
            </p-dropdown>
            <small *ngIf="((formGroup.controls.orgId.touched) && formGroup.controls.orgId.errors?.required)" class="p-invalid">
              {{ 'Common.Button.Required' | translate }}
            </small>
          </div>
        </div>

        <div class="field grid col-6 align-items-baseline">
          <label class="col-3 column-label">{{'ReceiptFormHeaderDetails.BillCompany' | translate}}</label>
          <div class="col-8 column-value">
            {{ warehousingHeader?.billCorp | optionsMapping:orgIdOptions | replaceNullWith:'-' }}
          </div>
        </div>
        <div class="field grid col-6 align-items-baseline">
          <label class="col-3 column-label"><span class="requiredStart">*</span>{{ 'ReceiptFormHeaderDetails.DocumentSubType' | translate }}</label>
          <div class="col-8 column-value">
            <p-dropdown formControlName="deliverySubType" [options]="deliverySubTypeOptions" [(ngModel)]="warehousingHeader.deliverySubType"
            ></p-dropdown>
            <small
                  *ngIf="((formGroup.controls.deliverySubType.touched) && formGroup.controls.deliverySubType.errors?.required)" class="p-invalid">
                  {{ 'Common.Button.Required' | translate }}
              </small>
          </div>
        </div>
      </div>
    </Form>
  </div>

  <div class="field">
    <div class="col">
        <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}" (click)="saveRelatedBill($event)"></button>
    </div>
  </div>
</p-dialog>
